export function isValidWebsite(value: string) {
  const website = value.trim();
  if (!website) return true;
  if (/\s/.test(website)) return false;

  try {
    const url = new URL(
      /^[a-z][a-z\d+\-.]*:\/\//i.test(website)
        ? website
        : `https://${website}`,
    );
    const domainParts = url.hostname.split(".");

    return (
      (url.protocol === "http:" || url.protocol === "https:") &&
      !url.username &&
      !url.password &&
      domainParts.length >= 2 &&
      domainParts.every(
        (part) =>
          part.length > 0 &&
          part.length <= 63 &&
          /^[a-z\d](?:[a-z\d-]*[a-z\d])?$/i.test(part),
      ) &&
      domainParts[domainParts.length - 1].length >= 2
    );
  } catch {
    return false;
  }
}

